import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import {
  FiAlignRight,
  FiXCircle,
  FiChevronDown,
  FiChevronRight,
} from "react-icons/fi";
import "./ResourcesContent.css";
import LTTPodcastNavbarmenu from "../PodCastFolder/LTTPodcastNavbarmenu";
import PodcastSideNavbar from "../PodCastFolder/PodcastSideNavbar";
import AOS from "aos";
import "aos/dist/aos.css";

function ResourcesContent() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);
  return (
    <>
      <div className="navbar-holder podcast-navbar-holder">
        <LTTPodcastNavbarmenu />
      </div>
      <div className="podcast-sidenavbar-holder">
        <PodcastSideNavbar />
      </div>
      <div className="video-container" id="main">
        <title>L-TT Podcast Resources</title>
        {/* <h1 class="sr-only" tabIndex={0}>
          Resources
        </h1> */}
        <img
          src={
            process.env.PUBLIC_URL +
            "/images/Banners/Resources-banner-mobile.png"
          }
          alt="home-banner"
          className="banner-img mobile-banner"
        />
        <img
          src={process.env.PUBLIC_URL + "/images/Banners/Resources-banner.png"}
          alt="resources"
          className="banner-img desktop-banner"
        />
        <ul className="breadcrumbs">
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/Home"
            >
              L&TT Home
            </NavLink>
            <span>/</span>
          </li>
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/LTT-Podcast"
            >
              L&TT Podcast
            </NavLink>
            <span>/</span>
          </li>
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/Resources"
            >
              Resources
            </NavLink>
          </li>
        </ul>
        <div className="all-headings-text-box">
          <h1 tabIndex={0}>L&TT Resources</h1>
          <p>
            Dive into a curated collection of tools and best practices to
            support every stage of your podcast journey.
          </p>
        </div>
        {/* <p data-aos="fade-up">
          Dive into a curated collection of tools and best practices to support
          every stage of your podcast journey.
        </p> */}
      </div>
      {/* first section */}
      <div className="watch-now-container">
        <div className="watch-now-wrap">
          <div className="watch-now-row row1" data-aos="fade-left">
            <div className="watch-now-box">
              <h3>
                <span>Learn</span> the essentials of how to create a{" "}
                <span>podcast</span> in this <span> step-by-step guide.</span>
              </h3>
              <p>
                From planning to recording and publishing, discover tips, tools,
                and strategies to launch a podcast your audience will love.
              </p>
              <p className="watch-now-link">
                <span href="#">Watch Now</span>
                {/* <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/Resources/open-arrow-right.png"
                  }
                  alt="icon"
                  className="open-arrow-right"
                /> */}
              </p>
            </div>
          </div>
          <div className="watch-now-row row2" data-aos="fade-right">
            <div className="watch-now-box">
              <div className="video-section">
                {/* <img
                  src={
                    process.env.PUBLIC_URL + "/images/Resources/play-icon.png"
                  }
                  alt="icon"
                  className="play-icon"
                /> */}
                <video
                  poster={
                    process.env.PUBLIC_URL +
                    "/images/Resources/resource-img-latest-one.png"
                  }
                  src={
                    process.env.PUBLIC_URL +
                    "/images/Resources/Podcast_Final.mp4"
                  }
                  width="100%"
                  height="auto"
                  controls
                ></video>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* second section */}
      <div className="queries-container">
        <div className="queries-wrap">
          <h3>For any queries or support, you may reach out to</h3>
          <p>
            <a href="mailto:L-TT.Podcast;">L-TT.Podcast</a>
          </p>
        </div>
      </div>
    </>
  );
}

export default ResourcesContent;
